import type { CSSProperties } from "react";
import { siteConfig } from "../../config/site";

export function Hero() {
  return (
    <section className="w-full bg-white">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-6 px-4 py-16 text-center sm:py-20">
        <span className="reveal reveal-1 rounded-full bg-[#f3eeff] px-5 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
          How It Works
        </span>

        <h1 className="max-w-[872px] text-3xl font-black uppercase leading-tight tracking-[0.5px] sm:text-5xl lg:text-[52px]">
          <div className="reveal-mask">
            <span
              className="block text-brand-purple"
              style={{ "--reveal-delay": "0.15s" } as CSSProperties}
            >
              Simple Steps.
            </span>
          </div>
          <div className="reveal-mask">
            <span
              className="block text-brand-teal"
              style={{ "--reveal-delay": "0.25s" } as CSSProperties}
            >
              Smoother Loan Journey.
            </span>
          </div>
        </h1>

        <p className="reveal reveal-3 max-w-[720px] text-base leading-7 text-[#475569] sm:text-lg">
          Explore, apply, and complete your loan journey through a simple
          digital process designed for the modern generation.
        </p>

        <a
          href={siteConfig.applyLink || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="reveal reveal-4 flex items-center gap-2 rounded-full bg-[#311042] px-9 py-[14px] text-sm font-semibold uppercase tracking-[0.4px] text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-opacity hover:opacity-90"
        >
          Start Your Application
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}
